import PrivateLayout from '~/components/layouts/PrivateLayout';
import BaseLayout from '~/components/layouts/BaseLayout';
import LoginPage from '~/pages/login';
import LogoutPage from '~/pages/logout';
import NotFoundPage from '~/pages/not-found';
import Home from '~/pages/homes';
import {BasicRoute, PrivateRoute} from '~/components/elements/AppRouter';
import AppointmentBooking from '~/pages/homes/appointments';
import ApplicationsForms from '~/pages/homes/applications-forms';
import RebookingAppointmentSuccess from '~/pages/homes/appointments/RebookingAppointmentSuccess';
import RebookingAppointmentFail from '~/pages/homes/appointments/RebookingAppointmentFail';
import ExpiredBookingAppointment from '~/pages/homes/appointments/ExpiredBookingAppointment';

export const publicRoutes: BasicRoute[] = [
  {
    path: '/',
    component: BaseLayout,
    exact: false,
    routes: [
      {path: '/', exact: true, component: Home},
      {path: '/appointment', component: AppointmentBooking},
      {path: '/booked-appointment', component: RebookingAppointmentSuccess},
      {path: '/booked-appointment-fail', component: RebookingAppointmentFail},
      {path: '/expired-booking-appointment', component: ExpiredBookingAppointment},
      {path: '/application-form', component: ApplicationsForms},
    ],
  },
];

export const privateRoutes: PrivateRoute[] = [
  {
    path: '/',
    component: PrivateLayout,
    exact: false,
    routes: [
      // {path: '/', exact: true, component: Home},
      // {path: '/logout', component: LogoutPage},
      {path: '/*', redirect: '/not-found', component: NotFoundPage},
    ],
  },
];
